module.exports = __webpack_public_path__ + "img/icon_tel_on.95280ebe.png";